var _g, _circle, _feFlood, _feBlend, _feGaussianBlur, _feFlood2, _feBlend2, _feGaussianBlur2, _stop, _stop2, _stop3, _stop4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopglobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 661,
    height: 602,
    viewBox: "0 0 661 602",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_1814)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 661,
    height: 602,
    rx: 20,
    fill: "#EFF1F2",
    style: {}
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_742_1814)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 509.5,
    cy: 450.5,
    r: 204.5,
    fill: "url(#paint0_linear_742_1814)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_742_1814)",
    style: {}
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -6.54736,
    cy: 94.4526,
    r: 237.908,
    transform: "rotate(-135 -6.54736 94.4526)",
    fill: "url(#paint1_linear_742_1814)",
    fillOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_742_1814",
    x: 125,
    y: 66,
    width: 769,
    height: 769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB",
    style: {}
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_742_1814"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_742_1814",
    x: -424.455,
    y: -323.455,
    width: 835.816,
    height: 835.816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB",
    style: {}
  }, _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  })), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_742_1814"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_742_1814",
    x1: 509.5,
    y1: 246,
    x2: 509.5,
    y2: 655,
    gradientUnits: "userSpaceOnUse",
    style: {}
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4666EE"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2E8CF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_742_1814",
    x1: -6.54736,
    y1: -143.455,
    x2: -6.54736,
    y2: 332.361,
    gradientUnits: "userSpaceOnUse",
    style: {}
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4666EE"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2E8CF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopglobe);
export default __webpack_public_path__ + "static/media/shopglobe.61cd727dfa89519573fdffb423b1c017.svg";
export { ForwardRef as ReactComponent };